import React, { useEffect, useState, useContext } from 'react'
import { Outlet } from 'react-router-dom'
import KYCMessage from '../../Components/Setting/KYCMessage'
import TopSec from '../../Components/Setting/TopSec'
import { UserContext } from '../../Context/UserContext'

function Settings() {
   const { userDetails } = useContext(UserContext);
   const accountStatus = "true"; 
   const [open, setOpen] = useState(false)
   const handleClose = () => setOpen(false)
   useEffect(() =>{
      if(accountStatus == 'false'){
        setOpen(true)
      }
   },[accountStatus, userDetails])
  return (
    <div>
     <KYCMessage
      open={open}
      handleClose= {handleClose}
    />
        <TopSec/>
        <Outlet/>
    </div>
  )
}

export default Settings